import { put, takeLatest, all } from "redux-saga/effects";
import * as Actions from "../../actions/billing/invoiceHistoryActions";

function* loadHelper({ value, responseData }) {
  try {
    if (responseData) {
      responseData.data.data = responseData?.data?.data?.filter((x) => !!x);
      if (responseData.data.data.length > 0) {
        responseData.data.data = responseData.data.data.map((item, index) => {
          if (item.invoiceType === "Invoice") {
            if (item.status === "Partially Cleared/UnPaid" || item.status === "Open/UnPaid") {
              item.status = "Amount due";
            } else if (item.status === "Cleared/Paid") {
              item.status = "Paid";
            }
          } else if (item.invoiceType === "Credit Note") {
            if (item.status === "Partially Cleared/UnPaid" || item.status === "Open/UnPaid" || item.status === "Cleared/Paid") {
              item.status = "Credit applied";
            }
          }
          item.accordianId = index;
          return item;
        });
        yield put(Actions.setInvoiceList(responseData.data.data));
        yield put(Actions.setActualInvoicelist(responseData.data.data));
        yield put(Actions.setFullSearchData(responseData.data.data));
        yield put(Actions.setActionName("onLoad"));
        yield put(Actions.setGoto(1));
        yield put(Actions.setActivePage(1));
      }
    } else {
      yield put(Actions.reset());
    }
  } catch (error) {
    yield put(Actions.reset());
    console.log(error);
  }
}

export default function* invoiceHistoryWatcher() {
  yield all([takeLatest(Actions.LOAD_DATA, loadHelper)]);
}
